import Lang from "@vendors-fr/messages";
import {getParams, returnMessageFromDialog, shippingCostDisplay} from "@plugins-fr/payment";
import {getCartAjaxUrl, setCartItem} from "@plugins-fr/script";
import {DialogMessage} from "@plugins-fr/dialogMessage";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {cartAddPricePopup} from "@commons/userTracks/viewActionName";
import {recordUserEventTrack, recordUserViewTrack} from "@commons/userTracks/userTrack";
import {checkoutPageCartAddPriceItemAddToCart, checkoutPageDeleteCartAddPriceItem} from "@commons/userTracks/eventActionName";

$(function() {
    var JS_VARS = JSON.parse(shops);
    var JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);

    $('.js_add_cart_addprice').on("change", function(){
        var itemBox = $(this).closest('.js_addprice_items');
        var itemId = itemBox.data('product-id');
        var itemStandardId = itemBox.data('product-standard-id');

        if( $(this).is(':checked') ) {
            cartAddPriceAddToCart(itemId, itemStandardId);
        } else {
            del_cart_addprice(itemStandardId, itemId);
        }
    });

    $('#js_cart_detail_area').on("click", '.js_cart_add_price_list_del_item', function() {
        var itemStandardId = $(this).parent().data('standard-id');
        var productId = $(this).parent().data('product-id');
        del_cart_addprice(itemStandardId, productId);
    });

    function del_cart_addprice(itemStandardId, productId) {
        var params = getParams();
        params.standard_id = itemStandardId;
        params.view = 'cart_list';
        params.qty = 1;
        params.cart_add_price = 1;
        const action = 'remove_cart_add_price_item';
        setCartItem(action, params, function(data) {
            if (typeof data !== 'undefined' && typeof data.status !== 'undefined' && data.status) {
                returnMessageFromDialog(Lang.get('frontend.product.cart_add_price.remove'));
                cancelSelectedCartAddPrice(itemStandardId);
            }

            if (data.status) {
                recordUserEventTrack(checkoutPageDeleteCartAddPriceItem, getCartAjaxUrl(action), {
                    'product_id': Number(productId),
                    'standard_id': Number(itemStandardId)
                });
            }

            shippingCostDisplay(data);
        });
    }

    // 預覽商品
    $('.js_addprice_lightbox').on('click', function(e){
        var addpriceItem = $(this).closest('.js_addprice_items');
        var productId = addpriceItem.data('product-id');
        var standardId = addpriceItem.data('product-standard-id');
        var checkboxElem = addpriceItem.find('.js_add_cart_addprice');
        var isSoldOut = false;

        if (addpriceItem.data("is-sold-out") === 1){
            isSoldOut = true;
        }

        e.preventDefault();

        const cartAddPirceDetailAJaxUrl = cart_addprice_detail_url + '/' + productId + '/' + standardId;
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_view_product'
            }),
            columnClass: 'col-md-10',
            closeIcon: false,
            icon: '',
            title: false,
            content: 'URL:' + cartAddPirceDetailAJaxUrl,
            draggable: false,
            offsetTop: 40,
            offsetBottom: 40,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'js_cancel btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
                },
                confirmButton: {
                    keys: ['enter'],
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.cart.cartaddprice.detail.btn.confirm') + '</span>',
                    btnClass: 'js_confirm btn_add_cart btn el_btn md solid el_rounded el_text m-0',
                    action: function(){
                        if (checkboxElem.length > 0) {
                            if (!checkboxElem.is(':checked')) {
                                checkboxElem.prop('checked', true);
                                checkboxElem.trigger('change');
                            } else {
                                returnMessageFromDialog(Lang.get('frontend.product.addcart.success'));
                            }
                        }
                    }
                }
            },
            onOpenBefore: function() {
                this.$el.find('.js_confirm').attr('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                this.$el.find('.js_confirm').data('hover-style', JS_VARS_THEME_STYLE.mainButtonHoverStyle);

                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                this.$el.find('.js_confirm, .btn_cancel').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            },
            contentLoaded: function(data, status, xhr){
                if (data == 'error') {
                    new DialogMessage({
                        'title': Lang.get('frontend.errormsg.cart.cart_add_price.loadingerror'),
                    }, {
                        'closeTimeout': 1200
                    }).handle();

                    this.close();
                    return false;
                } else {
                    this.setContent(data);
                    if (isSoldOut) {
                        this.$_confirmButton.hide();
                        $('.js_cancel').css('margin-right', 0);
                    }

                    recordUserViewTrack(cartAddPricePopup, cartAddPirceDetailAJaxUrl, {
                        'product_id': Number(productId),
                        'standard_id': Number(standardId)
                    });
                }
            },
        });
        // 針對ios可能將focus放在<body>上捲動 +1 做修正
        $('.add_product_inner').scrollTop(1);
    });

    // 手機版滿額購彈跳
    $('.js_addprice_wrap .js_addprice_items').on('mousedown', function(e){
        if( $(window).width() < 768 ) {
            e.preventDefault();

            $(".js_cartaddprice_mobile_area").addClass("fixed").fadeIn(500);
        }
    });


    // 滿額購商品，已加入效果
    var selectCartAddPrice = function (standardId) {
        var selectedCarAddPrices = $('.js_addprice_items[data-product-standard-id='+ standardId + ']');
        selectedCarAddPrices.addClass('active');

        const selectedInputDom = selectedCarAddPrices.find('.js_add_cart_addprice');
        selectedInputDom.prop('checked', true);

        const selectedInputLabelDom = selectedInputDom.next('label');
        selectedInputLabelDom.attr('style', selectedInputLabelDom.data('active-style'));

        const selectedDivDom = selectedCarAddPrices.find('> div');
        selectedDivDom.attr('style', selectedDivDom.data('active-style'));
    }

    // 滿額購商品，取消加入效果
    var cancelSelectedCartAddPrice = function (standardId) {
        var selectedCarAddPrices = $('.js_addprice_items[data-product-standard-id='+ standardId + ']');
        selectedCarAddPrices.removeClass('active');

        const selectedInputDom = selectedCarAddPrices.find('.js_add_cart_addprice');
        selectedInputDom.prop('checked', false);

        const selectedInputLabelDom = selectedInputDom.next('label');
        selectedInputLabelDom.attr('style', '');

        const selectedDivDom = selectedCarAddPrices.find('> div');
        selectedDivDom.attr('style', '');
    }

    // 返回
    $(".js_btn_cancel").on("click", function(){
        $('html, body').css({'overflow': '', 'height': ''});
        $(".js_cartaddprice_mobile_area").removeClass("fixed").hide();
    });

    /**
     * @param {*} productId
     * @param {*} standardId
     */
    var cartAddPriceAddToCart = function(productId, standardId) {
        var params = {
            product_id: productId,
            standard_id: standardId,
            quantity: '1',
            payment_id: '',
            view: 'cart_list'
        };

        selectCartAddPrice(standardId);
        const action= 'add_cart_add_prices';
        setCartItem(action, params, function(data) {
            if (typeof data != 'undefined' && typeof data.status != 'undefined' && ! data.status) {
                cancelSelectedCartAddPrice(standardId);
            } else {
                returnMessageFromDialog(Lang.get('frontend.product.addcart.success'));
            }

            if (data.status) {
                recordUserEventTrack(checkoutPageCartAddPriceItemAddToCart, getCartAjaxUrl(action), {
                    'product_id': Number(params.product_id),
                    'standard_id': Number(params.standard_id),
                    'quantity': Number(params.quantity),
                });
            }

            shippingCostDisplay(data);
        });
    };
});
